import { ActivityList } from "shared/components/activity";
import { useActivityListForParticipantsService } from "./service";

export default function ActivityListForParticipants() {
  const service = useActivityListForParticipantsService();
  const detailContext = {
    programId: service.programId,
    registrationId: service.registrationId
  };

  if (!service.associatedProgramActivities) {
    return null;
  }
  return (
    <div className="profile_wrapper activityListingPage activityParticipantView">
      <ActivityList
        isParticipant
        config={service.config}
        detailContext={detailContext}
        activityList={service.associatedProgramActivities}
        hasProgramWriteAuthority={service.hasProgramWriteAuthority}
        createSelectionRequestHandler={service.createSelectionRequestHandler}
        updateSelectionRequestHandler={service.updateSelectionRequestHandler}
        deleteSelectionRequestHandler={service.deleteSelectionRequestHandler}
        successHandlers={{ interestSuccessHandler: service.refreshMyActions }}
      />
    </div>
  );
}
